import { BaseModal } from "../../components/modalCommon/modalBase";
import { ModalBody } from "../../components/modalCommon/modalBody";
import { ModalFooter } from "../../components/modalCommon/modalFooter";
import { ModalHeader } from "../../components/modalCommon/modalHeader";
import { VerbalTestParametersContent } from "../../pages/verbal-audiometry/verbal-panels/verbalTestParameters";
import { useI18n } from "../../utils/translate/i18n/useI18n";
import type { VerbalTestParametersProps } from "../../type/verbalTest";

type VerbalTestParamsModalProps = Omit<VerbalTestParametersProps, "step"> & {
  isOpen: boolean;
  onClose: () => void;
};

export default function VerbalTestParamsModal({
  isOpen,
  onClose,
  useMicrophone,
  onToggleMicrophone,
  doWRS,
  onToggleDoWRS,
  doSRT,
  onToggleDoSRT,
  useSentences,
  onToggleUseSentences,
  extendedWRS,
  onToggleExtendedWRS,
  gender,
  ageCategory,
  onChangeGender,
  onChangeAgeCategory,
}: VerbalTestParamsModalProps) {
  const { t } = useI18n();

  return (
    <BaseModal open={isOpen} onClose={onClose} size="md">
      <ModalHeader title={t("Parametry badania")} onClose={onClose} />
      <ModalBody>
        <VerbalTestParametersContent
          useMicrophone={useMicrophone}
          onToggleMicrophone={onToggleMicrophone}
          doWRS={doWRS}
          onToggleDoWRS={onToggleDoWRS}
          doSRT={doSRT}
          onToggleDoSRT={onToggleDoSRT}
          useSentences={useSentences}
          onToggleUseSentences={onToggleUseSentences}
          extendedWRS={extendedWRS}
          onToggleExtendedWRS={onToggleExtendedWRS}
          gender={gender}
          ageCategory={ageCategory}
          onChangeGender={onChangeGender}
          onChangeAgeCategory={onChangeAgeCategory}
        />
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-primary px-4" onClick={onClose}>
          {t("OK")}
        </button>
      </ModalFooter>
    </BaseModal>
  );
}
